var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99967 0.333496C3.33301 0.333496 0.333008 3.3335 0.333008 7.00016C0.333008 10.6668 3.33301 13.6668 6.99967 13.6668C10.6663 13.6668 13.6663 10.6668 13.6663 7.00016C13.6663 3.3335 10.6663 0.333496 6.99967 0.333496ZM5.66634 10.3335L2.33301 7.00016L3.27301 6.06016L5.66634 8.44683L10.7263 3.38683L11.6663 4.3335L5.66634 10.3335Z",
    fill: "#9277FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/tickIcon.a7e12de65ed3a7ae631f29ef73753006.svg";
export { ForwardRef as ReactComponent };